import styled from "styled-components"
import theme from "../Theme"

const getColor = ({ error, warn, theme }) =>
  (error && theme.danger) || (warn && theme.warning) || theme.foregroundText

const Input = styled.input`
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25em;
  color: ${props => getColor(props)};
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: ${props => props.theme.borderRadius};

  &:disabled {
    opacity: 0.7;
  }
`

Input.defaultProps = {
  theme
}

export const ContactInput = Input.extend`
  height: 72px;
  margin: 10px 20px;
  font-size: 32px;
  color: #595959;
  font-family: "din-condensed";
  font-weight: 300;
`

export default Input



// WEBPACK FOOTER //
// ./src/UI/Form/Input.js